import React, { FC } from 'react';
import { Card, Col, Row, Space, Statistic } from "antd";
import { IProject } from "../../../models/project";
import MultiSeriesLineChart from "./LineChart";
import { Text } from "../../../theme/typography";
import { TYPOGRAPHY_SIZES } from "../../../theme/constants";
import MagnetomotiveForceChart from './MagnetomotiveForceChart';
import MagnetomotiveForceHarmonicChart from './MagnetomotiveForceHarmonicChart';
import ElectricLoadingChart from './ElectricLoadingChart';

interface IProps {
    topology: string;
    project: IProject;
}

type InlineSvgProps = {
    svgText: string;      // raw "<svg ...>...</svg>"
    className?: string;   // optional styling hook
    title?: string;       // accessible title if your SVG lacks one
};

function InlineSvg({ svgText, className, title }: InlineSvgProps) {
    return (
        <div
            className={className}
            style={{ width: '100%' }}
            role="img"
            aria-label={title}
            // NOTE: Only do this with trusted SVG strings
            dangerouslySetInnerHTML={{ __html: svgText }}
        />
    );
}

const Winding: FC<IProps> = (props) => {
    const { topology, project } = props;
    return (
        <>

            <Row gutter={24}>
                <Col span={5}>
                    <Card variant="borderless">
                        <Statistic
                            title="Winding Factor"
                            value={project.results.winding_factor !== undefined && project.results.winding_factor !== null ? Number(project.results.winding_factor) : 0}
                            precision={2}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col>
                {project.topology === "Induction Machine" && <>
                    <Col span={5}>
                        <Card variant="borderless">
                            <Statistic
                                title="Phase Resistanse [Ω]"
                                value={
                                    project.results.phase_resistance != null
                                        ? Number(project.results.phase_resistance)
                                        : undefined
                                }
                                precision={2}
                                valueStyle={{ color: '#3f8600' }}
                            />
                        </Card>
                    </Col>

                    <Col span={5}>
                        <Card variant="borderless">
                            <Statistic
                                title="Slot Leakage Inductance [mH]"
                                value={
                                    project.results.slot_leakage_inductance != null
                                        ? Number(project.results.slot_leakage_inductance) * 1000
                                        : undefined
                                }
                                precision={2}
                                valueStyle={{ color: '#3f8600' }}
                            />
                        </Card>
                    </Col>

                    <Col span={5}>
                        <Card variant="borderless">
                            <Statistic
                                title="End Winding Inductance [mH]"
                                value={
                                    project.results.end_winding_inductance != null
                                        ? Number(project.results.end_winding_inductance) * 1000
                                        : undefined
                                }
                                precision={2}
                                valueStyle={{ color: '#3f8600' }}
                            />
                        </Card>
                    </Col>
                </>}

                <Col span={4}>
                    <Card variant="borderless">
                        <Statistic
                            title="THD [%]"
                            value={project.results.thd}
                            precision={2}
                            valueStyle={{ color: '#3f8600' }}
                            suffix={"%"}
                        />
                    </Card>
                </Col>
            </Row>


            <Row style={{ marginTop: 24 }} gutter={24}>
                <Col span={12}>
                    <Card>
                        <Space direction={"vertical"}>

                            <Text strong style={{ fontSize: 16 }}>
                                Winding Layout
                            </Text>
                            <InlineSvg svgText={project?.results.geometry_winding as string} title="geometry_winding" className='svg-inline' />

                        </Space>
                    </Card>
                </Col>
                <Col span={12}>
                    <Space direction={"vertical"} style={{ width: '100%' }}>
                        <MagnetomotiveForceChart project={project} />

                        <MagnetomotiveForceHarmonicChart project={project} />

                        <ElectricLoadingChart project={project} />

                    </Space>
                </Col>
            </Row>
        </>
    )
}

export default Winding;